export default "<div class=\"ohn-echart\">\n\t<div echarts [options]=\"renderOptions\" style=\"width:100%\"></div>\n</div>";